export enum UserLoginType {
    user = 'user',
    member = 'member',
    sso = 'sso'
}

export enum LoginType {
    Account = 'account', // AccountPassword + PhoneCode
    AccountPassword = 'account',
    PhoneCode = 'phone_code',
    Wechat = 'oauth_wechat',
    Dingtalk = 'dingtalk',
    Wxwork = 'wxwork',
    Google = 'oauth_google',
    Lark = 'lark',
    SSO = 'sso',
    Tenant = 'tenant',
    FanruanPassport = 'fr_passport'
}
